import template from 'text!./templates/Textarea.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            item: '&'
        },
        template: template,
        link: function link($scope) {
            return $scope.$watch('item()', function (item) {
                $scope.applyNewValue = function () {
                    item.setValue($scope.fakeVM.value);
                };

                $scope.fakeVM = { value: item.getValue() };
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/table/Textarea.js
// module id = 104
// module chunks = 0